import React from 'react';
import './ReviewTime.styl';
import moment from 'moment';
import {CalendarDaysIcon} from '@components/icon/CalendarDaysIcon';
import Button from '@material-ui/core/Button';

export default function ReviewTime({plan, review, isRecipient, toggleModify}) {
  const time = review.completedAt ? review.completedAt : review.scheduleAt;
  return (
    <div className="review-time">
      <CalendarDaysIcon tooltip="Time" />
      <div className="flex-column">
        <div className="flex">
          <div className="date-time">{time.clone().format('dddd, MMM Do, h:mma z')}</div>
          {!review.completedAt && !plan.unscheduled() && time.isBefore(moment()) && (
            <div className="overdue">PAST-DUE</div>
          )}
        </div>
        {review.status === 'SCHEDULED' && !isRecipient && (
          <Button className="reschedule" size="small" onClick={toggleModify}>
            Reschedule
          </Button>
        )}
      </div>
    </div>
  );
}
